module.exports = __webpack_public_path__ + "media/images/advisor/img_1_3-55c6e74dab98de5845aff4d11ce9e678.png";